import {
  HiOutlineIdentification,
  HiHome,
  HiDocument,
  HiUsers,
  HiOutlineKey,
  HiFolderOpen,
  HiOutlineViewList,
  HiNewspaper,
  HiOutlineCube,
  HiBookOpen,
  HiOutlineCollection,
} from "react-icons/hi";
import { MdFactory } from "react-icons/md";
import { BsTools, BsFillNutFill } from "react-icons/bs";
import { Sidebar } from "flowbite-react";
import { FaUserTag, FaBook } from "react-icons/fa";
import { Link } from "react-router-dom";
import { HiOutlineTag } from "react-icons/hi";

export default function SideNav() {
  return (
    <>
      <div className="sticky bg-slate-100 h-full hidden lg:block">
        <Sidebar className="bg-slate-100 w-[60px] lg:w-[256px] transition-width transition-slowest">
          <Sidebar.Items>
            <Sidebar.ItemGroup>
              {/* <div className='flex content-center'>
                <Sidebar.Item href='/dashboard' icon={HiHome}>
                  <div className='hidden lg:block'>Dashboard</div>
                </Sidebar.Item>
              </div> */}
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/users" icon={HiUsers}>
                  User List
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/clients" icon={FaUserTag}>
                  Clients
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/manufacturers" icon={MdFactory}>
                  Manufacturers
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/categories" icon={HiOutlineTag}>
                  Categories
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item
                  as={Link}
                  to="/subcategories"
                  icon={HiOutlineCollection}
                >
                  SubCategories
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item
                  as={Link}
                  to="/equipmentlist"
                  icon={HiOutlineCube}
                >
                  Wholegoods
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/partslist" icon={BsFillNutFill}>
                  Parts
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/manuallist" icon={FaBook}>
                  Manuals
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item
                  as={Link}
                  to="/admin/order/list"
                  icon={HiNewspaper}
                >
                  Orders
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/warrantylist" icon={HiNewspaper}>
                  Warranty Claims
                </Sidebar.Item>
              </div>
              <div className="flex content-center">
                <Sidebar.Item as={Link} to="/siteresources" icon={BsTools}>
                  Site Pages
                </Sidebar.Item>
              </div>
              {/* <div className='flex content-center'>
                <Sidebar.Item href='/contactforms' icon={HiUsers}>
                  <div className='hidden lg:block'>Contact Forms List</div>
                </Sidebar.Item>
              </div> */}
              <div className="flex content-center">
                <Sidebar.Collapse label="Forms" icon={HiOutlineViewList}>
                  <div className="flex content-center">
                    <Sidebar.Item href="/contactforms" icon={HiUsers}>
                      <div className="hidden lg:block">
                        Potential Opportunities
                      </div>
                    </Sidebar.Item>
                  </div>
                  <div className="flex content-center">
                    <Sidebar.Item href="/requestQuotes" icon={HiUsers}>
                      <div className="hidden lg:block">Quote Requests</div>
                    </Sidebar.Item>
                  </div>
                </Sidebar.Collapse>
              </div>
              {/* <div className='flex content-center'>
              <Sidebar.Item href='/members/directory' icon={HiDocument}>
                <div className='hidden lg:block'>Member Directory</div>
              </Sidebar.Item>
            </div>
            <div className='flex content-center'>
              <Sidebar.Item href='/members/resources' icon={HiFolderOpen}>
                <div className='hidden lg:block'>Member Resources</div>
              </Sidebar.Item>
            </div> */}
            </Sidebar.ItemGroup>
          </Sidebar.Items>
        </Sidebar>
      </div>
    </>
  );
}
